<div class="header">
  <div class="header__text">
    <h3 *ngIf="titleKey" class="header__title">{{ titleKey | translate }}</h3>
    <p *ngIf="descriptionKey" class="header__description">{{ descriptionKey | translate }}</p>
  </div>
  <div *ngIf="showHeaderActions" class="header__actions">
    <button
      mat-flat-button
      color="primary"
      type="button"
      data-cy="json-editor-confirm"
      [disabled]="!!parseError"
      (click)="onConfirmClick()"
    >
      {{ confirmButtonKey | translate }}
    </button>
    <button
      mat-stroked-button
      color="warn"
      type="button"
      data-cy="json-editor-discard"
      (click)="onDiscardClick()"
    >
      {{ discardButtonKey | translate }}
    </button>
  </div>
</div>

<div class="editor">
  <textarea
    #editor
    class="editor__textarea"
    spellcheck="false"
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    data-cy="json-editor-textarea"
    [ngModel]="editorText"
    (ngModelChange)="onTextChange($event)"
    (keydown)="onKeydown($event)"
  ></textarea>
  <div *ngIf="parseError" class="editor__error" data-cy="json-editor-error">
    {{ parseError }}
  </div>
</div>
